var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_vm.selectedLoader,{tag:"component"}),(_vm.loaderText)?_c('span',{staticClass:"loader-text f14"},[_vm._v(" "+_vm._s(_vm.loaderText)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }